import Button from 'Components/Button';
import Card from 'Components/Card';
import ProgressBar from 'Components/ProgressBar';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import PagosService from 'Services/Http/Pagos.service';
import { formatCurrency } from 'Utils/Functions';

export const Pagos = (props) => {
  const { folioCredito } = props;
  const [loader, setLoader] = useState(false);
  const [rowsData, setRowsData] = useState([]);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (folioCredito) {
      getDataAmortizacion(folioCredito);
    }
  }, [folioCredito]);
  useEffect(() => {
    if (rows) {
      createRows();
    }
  }, [rows]);
  const getDataAmortizacion = async () => {
    setLoader(true);
    try {
      const response = await PagosService.getAmortizacion(folioCredito);
      setRows(response.data);
      setLoader(false);
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };
  const createRows = () => {
    let data = rows.map((item, index) => (
      <tr
        key={`pagos-row-${folioCredito}-${index}`}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4">{item.numeroPago}</td>
        <td className="px-6 py-4">{formatCurrency(item.montoPago || 0)}</td>
        <td className="px-6 py-4">{moment(item.fechaPago).format('DD/MM/YYYY')}</td>
        <td className="px-6 py-4">{formatCurrency(item.montoDeposito || 0)}</td>
        <td className="px-6 py-4">{item.atraso > 0 ? item.atraso : item.atrasoActual}</td>
        <td className="px-6 py-4">{item.idDeposito}</td>
      </tr>
    ));
    setRowsData(data);
  };
  const refresh = async () => {
    await getDataAmortizacion();
  };
  return (
    <Card title="Pagos">
      <div className="my-3">
        <Button iconprefix={['fa', 'arrows-rotate']} onClick={() => refresh()} />
      </div>
      <div className="relative overflow-x-auto sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Monto Requerido
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha Pago
              </th>
              <th scope="col" className="px-6 py-3">
                Monto Aplicado
              </th>
              <th scope="col" className="px-6 py-3">
                Atraso
              </th>
              <th scope="col" className="px-6 py-3">
                ID Deposito
              </th>
            </tr>
          </thead>
          <tbody>{rowsData}</tbody>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </Card>
  );
};

Pagos.propTypes = {
  folioCredito: PropTypes.number.isRequired
};
